module.exports = __webpack_public_path__ + "static/img/mifan.5d895f5b.png";